<template>
  <span
    :style="{ display }"
    class="r-text-bold r-link-button"
    v-on="$listeners" >{{ text }}</span>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    text: String,
    display: {
      type: String,
      validator: val => ['block', 'inline'].includes(val),
    },
  },

};
</script>
